
// ============================================
// SHOPIFY-COMPATIBLE VARIANT FILTER
// Works with Shopify's dynamic updates
// ============================================

(function() {
  'use strict';
  
  console.log('🛒 Loading Shopify-compatible variant filter...');
  
  // State
  let currentVariant = null;
  let isProcessing = false;
  let mediaGallery = null;
  
  // Wait for Shopify to initialize
  function waitForShopify() {
    return new Promise((resolve) => {
      if (window.Shopify && document.querySelector('media-gallery')) {
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          if (window.Shopify && document.querySelector('media-gallery')) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
        
        // Timeout after 5 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          resolve();
        }, 5000);
      }
    });
  }
  
  // Listen for Shopify variant changes
  function listenForVariantChanges() {
    // Method 1: Listen to Shopify's custom events
    document.addEventListener('variant:change', function(event) {
      console.log('Shopify variant changed:', event.detail);
      handleVariantChange(event.detail.variant);
    });
    
    // Method 2: Listen to radio button changes
    document.addEventListener('change', function(event) {
      if (event.target.matches('fieldset.js.product-form__input input[type="radio"]')) {
        setTimeout(() => {
          handleVariantChange(event.target.value);
        }, 100);
      }
    });
    
    // Method 3: Shopify's product form changes
    const productForm = document.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('change', function() {
        setTimeout(updateMediaFilter, 150);
      });
    }
    
    console.log('👂 Listening for variant changes...');
  }
  
  // Handle variant change
  function handleVariantChange(variantName) {
    if (isProcessing || currentVariant === variantName) return;
    
    isProcessing = true;
    currentVariant = variantName;
    
    console.log(`🔄 Switching to variant: ${variantName}`);
    
    // Small delay to let Shopify update the DOM
    setTimeout(() => {
      filterMediaByVariant(variantName);
      isProcessing = false;
    }, 200);
  }
  
  // Filter media by variant
  function filterMediaByVariant(variantName) {
    // Get fresh media gallery reference
    mediaGallery = document.querySelector('media-gallery.product__column-sticky');
    if (!mediaGallery) {
      console.warn('Media gallery not found');
      return;
    }
    
    // Get ALL slides (including dynamically loaded ones)
    const allSlides = Array.from(mediaGallery.querySelectorAll('li[id^="Slide-"]'));
    if (allSlides.length === 0) {
      console.warn('No slides found');
      return;
    }
    
    console.log(`📷 Found ${allSlides.length} slides for filtering`);
    
    // Filter logic
    let visibleCount = 0;
    
    allSlides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      const alt = img?.alt?.trim() || '';
      
      // Check if slide belongs to current variant
      const isMatchingVariant = alt.includes(variantName);
      
      if (isMatchingVariant) {
        // Show slide
        slide.style.display = '';
        slide.style.order = visibleCount;
        visibleCount++;
        
        // Update active state
        if (visibleCount === 1) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
        
        // Show matching thumbnail
        showMatchingThumbnail(slide, visibleCount);
      } else {
        // Hide slide
        slide.style.display = 'none';
        slide.classList.remove('is-active');
      }
    });
    
    // If no matches found, show all
    if (visibleCount === 0) {
      console.log(`No images found for "${variantName}", showing all`);
      showAllMedia();
      return;
    }
    
    // Update slider counter
    updateSliderCounter(visibleCount);
    
    console.log(`✅ Showing ${visibleCount} images for "${variantName}"`);
  }
  
  // Show matching thumbnail for a slide
  function showMatchingThumbnail(slide, orderIndex) {
    const mediaId = slide.getAttribute('data-media-id');
    if (!mediaId) return;
    
    const thumbnail = document.querySelector(`li[id^="Slide-Thumbnails-"] button[data-target="${mediaId}"]`)?.closest('li');
    if (thumbnail) {
      thumbnail.style.display = '';
      thumbnail.style.order = orderIndex - 1;
      
      if (orderIndex === 1) {
        thumbnail.classList.add('is-active');
        const button = thumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');
      } else {
        thumbnail.classList.remove('is-active');
        const button = thumbnail.querySelector('button');
        if (button) button.removeAttribute('aria-current');
      }
    }
  }
  
  // Show all media
  function showAllMedia() {
    mediaGallery = document.querySelector('media-gallery.product__column-sticky');
    if (!mediaGallery) return;
    
    const allSlides = Array.from(mediaGallery.querySelectorAll('li[id^="Slide-"]'));
    const allThumbnails = Array.from(mediaGallery.querySelectorAll('li[id^="Slide-Thumbnails-"]'));
    
    // Show all slides
    allSlides.forEach((slide, index) => {
      slide.style.display = '';
      slide.style.order = '';
      slide.classList.remove('is-active');
    });
    
    // Show all thumbnails
    allThumbnails.forEach((thumb, index) => {
      thumb.style.display = '';
      thumb.style.order = '';
      thumb.classList.remove('is-active');
      const button = thumb.querySelector('button');
      if (button) button.removeAttribute('aria-current');
    });
    
    // Activate first elements
    if (allSlides.length > 0) allSlides[0].classList.add('is-active');
    if (allThumbnails.length > 0) {
      allThumbnails[0].classList.add('is-active');
      const button = allThumbnails[0].querySelector('button');
      if (button) button.setAttribute('aria-current', 'true');
    }
    
    // Update counter
    updateSliderCounter(allSlides.length);
    
    currentVariant = null;
    console.log('✅ Showing all media');
  }
  
  // Update slider counter
  function updateSliderCounter(count) {
    if (!mediaGallery) return;
    
    const totalCounter = mediaGallery.querySelector('.slider-counter--total');
    const currentCounter = mediaGallery.querySelector('.slider-counter--current');
    
    if (totalCounter) totalCounter.textContent = count;
    if (currentCounter) currentCounter.textContent = '1';
    
    // Update slider buttons
    const buttons = mediaGallery.querySelectorAll('.slider-button');
    buttons.forEach(button => {
      button.disabled = count <= 1;
    });
  }
  
  // Update media filter (called when Shopify updates media)
  function updateMediaFilter() {
    if (!currentVariant) return;
    
    console.log('🔄 Shopify updated media, reapplying filter...');
    
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      filterMediaByVariant(currentVariant);
    }, 300);
  }
  
  // Initialize
  async function initialize() {
    console.log('🚀 Initializing Shopify variant filter...');
    
    // Wait for Shopify
    await waitForShopify();
    
    // Start listening for changes
    listenForVariantChanges();
    
    // Apply initial variant
    const initialVariant = document.querySelector('fieldset.js.product-form__input input[type="radio"]:checked');
    if (initialVariant) {
      console.log(`🎨 Initial variant: ${initialVariant.value}`);
      setTimeout(() => {
        handleVariantChange(initialVariant.value);
      }, 500);
    }
    
    console.log('✅ Shopify variant filter ready!');
    
    // Add manual controls for debugging
    window.shopifyVariantFilter = {
      filter: handleVariantChange,
      showAll: showAllMedia,
      current: () => currentVariant,
      refresh: updateMediaFilter
    };
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
})();